/* Included by several sections on one page; the browser runs every copy, so
   everything below runs once and the rest is skipped. */
if (!window.__lautioStoryDone) {
window.__lautioStoryDone = true;
/* Lautio story sections: reveals, the counting numerals, and the ledger rail.
   Everything here is progressive: without JavaScript the sections are simply
   visible and the numbers already show their final value. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveals: rise in once, never again.
  //
  // Two things beyond the observer. A fast scroll can carry an element past
  // the viewport between two deliveries, and it would then stay at opacity 0
  // for the rest of the visit, so a cheap sweep catches anything already
  // above the fold. And the Theme Editor replaces a section's markup without
  // re-running this file, so the new nodes are observed through the refresh
  // hook at the bottom - without it an edited section renders blank.
  window.__lautioStoryRefreshers = window.__lautioStoryRefreshers || [];
  var io = null;
  var observeReveals = function (root) {
    var nodes = (root || document).querySelectorAll('.lautio-s [data-reveal]');
    if (!io) { nodes.forEach(function (el) { el.classList.add('is-in'); }); return; }
    nodes.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  };
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
  }
  observeReveals(document);
  if (io) {
    var sweeping = false;
    var sweep = function () {
      sweeping = false;
      document.querySelectorAll('.lautio-s [data-reveal]:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < window.innerHeight * 0.88 && r.top < window.innerHeight) { el.classList.add('is-in'); io.unobserve(el); }
      });
    };
    window.addEventListener('scroll', function () { if (!sweeping) { sweeping = true; requestAnimationFrame(sweep); } }, { passive: true });
  }
  window.__lautioStoryRefreshers.push(observeReveals);

  // Counting numerals: from zero to the value, easing out, tabular figures so
  // the width does not breathe while counting.
  function ease(t) { return 1 - Math.pow(1 - t, 5); }
  function count(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var decimals = (el.getAttribute('data-decimals') | 0);
    var prefix = el.getAttribute('data-prefix') || '';
    var start = null;
    var duration = 1400;
    function step(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      var v = target * ease(t);
      el.firstChild.nodeValue = prefix + v.toFixed(decimals);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window && !reduce) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        count(e.target);
        cio.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    var observeCounters = function (root) {
      (root || document).querySelectorAll('.lautio-s [data-count]').forEach(function (el) { cio.observe(el); });
    };
    observeCounters(document);
    window.__lautioStoryRefreshers.push(observeCounters);
  }

  // The header is one fixed bar over every section. Over the ivory sections
  // its ivory type would vanish, so each light section reports when it sits
  // under the bar and the header switches to ink (body.lautio-on-light, the
  // same hook the scroll chapters use for their pale scrims).
  // The three compact viewers in the shop cards are .lautio-board3d too; they
  // are not observed, because each one crossing the band flipped the bar back
  // to ivory over the ivory shop. Anything marked data-lautio-light counts as
  // light (the collage below the nature lead included).
  if ('IntersectionObserver' in window) {
    var hio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var light = e.target.hasAttribute('data-lautio-light');
        // a dark element nested inside a light section does not speak for it
        if (!light && e.target.closest('[data-lautio-light]')) return;
        document.body.classList.toggle('lautio-on-light', light);
      });
    }, { rootMargin: '-40px 0px -88% 0px', threshold: 0 });
    var observeLights = function (root) {
      (root || document).querySelectorAll('[data-lautio-light], .lautio-s.lautio-island, .lautio-board3d:not(.lautio-board3d--card), [data-lautio-rack]').forEach(function (el) { hio.observe(el); });
    };
    observeLights(document);
    window.__lautioStoryRefreshers.push(observeLights);

    // The bar is fixed and its links take pointer events, so over the last
    // screen it sat on the launch signup: a tap meant for "Notify me" reached
    // "Choose your size". The footer menu repeats every link, so the bar
    // steps aside there instead.
    // the site footer is the shared one from footer-group.json now; the old
    // homepage footer menu is kept as a fallback selector
    var end = document.querySelector('.shopify-section-group-footer-group, #lautio-footer-nav');
    if (end) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { document.body.classList.toggle('lautio-at-end', e.isIntersecting); });
      }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 }).observe(end);
    }
  }

  // The ledger rail: a line that draws down the list as the reader moves
  // through it, so the five truths read as one account.
  var lists = document.querySelectorAll('.lautio-truths__list');
  if (lists.length && !reduce) {
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      lists.forEach(function (list) {
        var r = list.getBoundingClientRect();
        var p = (vh * 0.72 - r.top) / r.height;
        p = Math.max(0, Math.min(1, p));
        list.style.setProperty('--ledger', p.toFixed(3));
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  } else {
    lists.forEach(function (list) { list.style.setProperty('--ledger', '1'); });
  }
})();

/* Real media, real motion: parallax on the lead photograph, a strip that
   travels with the scroll, a small pointer tilt on photographs, and the
   turntables in the shop cards. Transform-only, one animation frame per
   scroll, nothing that fights the page. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  // parallax: the media moves a fraction of its host's travel through the
  // viewport - the lead photograph slower than the page, the collage tiles
  // each at their own small pace (a negative factor drifts the other way)
  var paras = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  window.__lautioStoryRefreshers = window.__lautioStoryRefreshers || [];
  window.__lautioStoryRefreshers.push(function () {
    paras = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  });
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    paras.forEach(function (el) {
      var host = el.parentElement;
      var r = host.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var f = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      var centre = (r.top + r.height / 2) - vh / 2;   // 0 when the host is centred
      el.style.transform = 'translate3d(0,' + (centre * f).toFixed(1) + 'px,0)';
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  if (!reduce && paras.length) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  // tilt: photographs lean a few degrees towards the pointer
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ty', (x * 7).toFixed(2) + 'deg');
        el.style.setProperty('--tx', (-y * 7).toFixed(2) + 'deg');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--ty', '0deg');
        el.style.setProperty('--tx', '0deg');
      });
    });
  }

  // turntables: 36 rendered frames; hover or drag turns the board, and it
  // idles round slowly on its own once the frames are in
  document.querySelectorAll('.lautio-spin').forEach(function (el) {
    var pattern = el.getAttribute('data-spin-src');   // e.g. .../lautio-turn-large-00.webp
    var count = parseInt(el.getAttribute('data-frames') || '36', 10);
    var img = el.querySelector('img');
    if (!pattern || !img) return;
    var frames = [], loaded = 0, ready = false, idx = 0, auto = true, raf = null, last = 0;
    var vel = 0;   // frames per second while idling
    var pos = 0;   // the fractional turn; idx is the frame actually shown
    // asset URLs carry a ?v= query, so the frame number is replaced wherever it sits
    function src(i) { return pattern.replace(/-00\.webp/, '-' + (i < 10 ? '0' + i : String(i)) + '.webp'); }
    function show(i) {
      i = ((Math.round(i) % count) + count) % count;
      if (i === idx && ready) return;
      idx = i;
      if (frames[i] && frames[i].complete) img.src = frames[i].src;
    }
    function load() {
      if (frames.length) return;
      for (var i = 0; i < count; i += 1) {
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () { loaded += 1; if (loaded === count) { ready = true; if (!reduce) tick(performance.now()); } };
        im.src = src(i);
        frames.push(im);
      }
    }
    function tick(now) {
      if (!ready) return;
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (auto) { vel = vel + (2.4 - vel) * dt * 2; pos += vel * dt; show(pos); } else { pos = idx; }
      raf = requestAnimationFrame(tick);
    }
    // hover: the pointer's x maps to the angle; drag on touch
    var dragging = false, startX = 0, startIdx = 0;
    el.addEventListener('pointerenter', function () { auto = false; el.classList.add('is-touched'); });
    el.addEventListener('pointerleave', function () { auto = true; dragging = false; });
    el.addEventListener('pointerdown', function (e) { dragging = true; startX = e.clientX; startIdx = idx; auto = false; el.classList.add('is-touched'); try { el.setPointerCapture(e.pointerId); } catch (err) {} });
    el.addEventListener('pointerup', function () { dragging = false; if (!window.matchMedia('(hover: hover)').matches) auto = true; });
    el.addEventListener('pointermove', function (e) {
      if (!ready) return;
      if (dragging) { show(startIdx + (e.clientX - startX) / (el.clientWidth / count)); return; }
      if (e.pointerType === 'mouse') { var r = el.getBoundingClientRect(); show(((e.clientX - r.left) / r.width) * count); }
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { load(); io.disconnect(); } }); }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else { load(); }
  });
})();

/* the phone menu: one button, the whole page listed, closes on a choice */
(function () {
  var toggle = document.querySelector('[data-lautio-menu-toggle]');
  var menu = document.querySelector('[data-lautio-menu]');
  if (!toggle || !menu) return;
  var open = function (on) {
    menu.hidden = !on;
    toggle.setAttribute('aria-expanded', String(on));
    document.body.classList.toggle('lautio-menu-open', on);
  };
  toggle.addEventListener('click', function () { open(menu.hidden); });
  menu.querySelectorAll('[data-lautio-menu-link]').forEach(function (a) { a.addEventListener('click', function () { open(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) open(false); });
})();

}

/* Outside the once-only guard on purpose. The Theme Editor rebuilds a section's
   markup without re-running this file, and every element in these sections
   starts at opacity 0 waiting for .is-in - so an edited section would render
   as an empty band. Each part of the file registers what it needs re-applied. */
document.addEventListener('shopify:section:load', function (e) {
  var refreshers = window.__lautioStoryRefreshers || [];
  for (var i = 0; i < refreshers.length; i += 1) {
    try { refreshers[i](e.target); } catch (err) { /* one refresher must not stop the rest */ }
  }
});
